import styled from '@emotion/styled'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import tokens from '../../design/design-tokens/tokens'

import colorNames from '../../design/color-names'
import lockSvg from '../../img/icons/lock-keyhole-gray.svg'
import { INPUT_TEXT_VARIANT_DANGER, InputText } from './InputText'

export const INPUT_TEXT_ICON_VARIANT_DANGER = INPUT_TEXT_VARIANT_DANGER

export const InputTextIcon = ({
  placeholder,
  className,
  inputClassName,
  disabled,
  value,
  variant,
  onChange,
  onBlur,
  name,
  id,
  onKeyUp,
  'data-mu-test': dataAttributeTest,
  icon,
  tooltip,
  ...otherProps
}) => {
  const props = {
    placeholder,
    className: inputClassName,
    disabled,
    value,
    onChange,
    onBlur,
    name,
    variant,
    id,
    onKeyUp,
    'data-mu-test': dataAttributeTest,
    ...otherProps,
  }
  return (
    <Container
      data-tip={tooltip}
      className={className}
      data-mu-test={classNames('input-text-icon', dataAttributeTest)}
    >
      {icon && (
        <IconWrapper disabled={disabled} variant={variant}>
          {icon}
        </IconWrapper>
      )}
      <StyledInputTextIcon {...props} />
    </Container>
  )
}

const Container = styled.span`
  display: flex;
  align-items: center;
`

const IconWrapper = styled.span`
  width: 36px;
  height: 36px;
  padding: 8px;

  text-align: center;

  border-style: solid;
  border-radius: ${tokens.InputTextIcon.borderRadius.icon};
  border-width: ${tokens.InputTextIcon.borderWidth};
  border-color: ${({ disabled, variant }) =>
    disabled
      ? tokens.InputTextIcon.borderColor_disabled
      : variant === INPUT_TEXT_ICON_VARIANT_DANGER
        ? tokens.InputTextIcon.borderColor_danger
        : tokens.InputTextIcon.borderColor} !important;

  transition: all 0.3s ease;
  position: relative;
  > img {
    max-width: 20px;
    max-height: 20px;
  }
`

const StyledInputTextIcon = styled(InputText)`
  width: 100%;
  input {
    border-left: 0 !important;
    border-radius: ${tokens.InputTextIcon.borderRadius.input} !important;
    border-width: ${tokens.InputTextIcon.borderWidth} !important;
    border-color: ${({ disabled, variant }) =>
      disabled
        ? tokens.InputTextIcon.borderColor_disabled
        : variant === INPUT_TEXT_ICON_VARIANT_DANGER
          ? tokens.InputTextIcon.borderColor_danger
          : tokens.InputTextIcon.borderColor} !important;

    :hover {
      border-color: ${({ disabled, variant }) =>
        disabled
          ? tokens.InputTextIcon.borderColor_disabled
          : variant === INPUT_TEXT_ICON_VARIANT_DANGER
            ? tokens.InputTextIcon.borderColor_danger
            : tokens.InputTextIcon.borderColor} !important;
    }
  }
`

const StyledIcon = styled.img`
  color: ${colorNames.boulder};
  max-width: 20px;
  max-height: 20px;
`

InputTextIcon.defaultProps = {
  icon: <StyledIcon src={lockSvg} />,
}

InputTextIcon.propTypes = {
  disabled: PropTypes.bool,
  inputClassName: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
  icon: PropTypes.node,
  tooltip: PropTypes.string,
  variant: PropTypes.oneOf([
    INPUT_TEXT_ICON_VARIANT_DANGER,
    '',
    null,
    undefined,
  ]),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string,
}
